import React from "react";

import { LogoContainer, LogoFeedMe, DisplayHelp } from "./HeaderGame.styles";

const HeaderGame = ({ handleModal }) => (
	<div className="container-fluid d-flex flex-row justify-content-around  pt-3 pb-3">
		<LogoFeedMe>
			<img src="/fblogo.jpg" alt="Enginyat i programat per Xavi Torner - xtorner@gmail.com" />
		</LogoFeedMe>
		<LogoContainer>
			<img src="/logo_encreuat.svg" alt="Emblema encreua't" />
		</LogoContainer>
		<DisplayHelp onClick={handleModal}>
			<span>?</span>
		</DisplayHelp>
	</div>
);

export default HeaderGame;
